<template>
    <GenericModal ref="modalRef" modal-title="Promote Pre-Consultation" v-slot="{ hide }">
        <div class="px-4 mb-4"><h5 class="">Confirm to promote this pre-consultation?</h5></div>
        <form>
            <fieldset :disabled="isSubmitting" class="px-4">
                <ConsultationTypesField
                    name="consultationMethodId"
                    label="Consultation Method"
                ></ConsultationTypesField>
                <div class="pb-4 hstack gap-2 justify-content-end">
                    <button
                        @click="hide"
                        class="btn btn-overlay-dark"
                        type="button"
                        :disabled="isBusy">
                        Cancel
                    </button>
                    <ButtonWithSpinner
                        @click="onPromote(hide)"
                        class="btn btn-dark"
                        type="button"
                        :is-busy="isBusy"
                        :disabled="isBusy">
                        Promote
                    </ButtonWithSpinner>
                </div>
            </fieldset>
        </form>
    </GenericModal>
</template>

<script setup lang="ts">
import { ButtonWithSpinner, GenericModal } from '@/modules/core/components';
import { ref } from 'vue';
import { usePortalConsultationsStore } from '../../store';
import { ConsultationTypesField } from './forms';
import { useForm } from 'vee-validate';
import { object, string } from 'yup';

interface Props {
    preConsultationId: string;
}

const props = defineProps<Props>()

const consultationsStore = usePortalConsultationsStore();

const isBusy = ref(false);

const modalRef = ref<InstanceType<typeof GenericModal>>();

const promoteSchema = object({
    consultationMethodId: string().trim().required('Consultation method is a required field').default('').label('Consultation Method')
})

const {
    handleSubmit,
    isSubmitting,
    values,
} = useForm({
    validationSchema: promoteSchema
})

const onPromote = (hideModal?: () => void) =>
    handleSubmit(async (formValues, { resetForm }) => {
        try {
            isBusy.value = true
            await consultationsStore.promotePreConsultationById(
                props.preConsultationId,
                formValues.consultationMethodId
            )
            consultationsStore.getPreConsultations(1)

            // close modal if provided
            hideModal && hideModal()

            resetForm()
        } finally {
            isBusy.value = false
        }
    })()

defineExpose({
    show: () => modalRef.value?.show()
})
</script>

<style scoped>

</style>